import React from "react"
import ServiceRow from "../../../VenueServicesList/ServiceRow"
import ComingSoon from "../../DeliveryInfo/ComingSoon"
import FirstSlot from "../../DeliveryInfo/FirstSlot"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function ServiceBox(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { service, venue, onClick, orderMode } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function noVenue() {
    return <div></div>
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // GUARD
  if (!venue) {
    return noVenue()
  }

  let venueInfo = [venue.subtitle || ""]
  if (venue.accepts_cash && venue.accepts_stripe) {
    venueInfo.push(I18n.t("pages.locations.venues.venue_box.payments.card_and_cash"))
  } else if (venue.accepts_stripe) {
    venueInfo.push(I18n.t("pages.locations.venues.venue_box.payments.cash"))
  } else if (venue.accepts_stripe) {
    venueInfo.push(I18n.t("pages.locations.venues.venue_box.payments.credit_card"))
  }

  if (!venue.accepts_discount_codes) {
    venueInfo.push(I18n.t("pages.locations.venues.venue_box.payments.no_coupon"))
  }

  const venueDesc = venueInfo.join(" • ")

  // -------------------------------------

  return (
    <div
      className={`${style.serviceCard}`}
      onClick={() => {
        onClick(venue, service)
      }}
    >
      <ServiceRow className="m-0" service={service} />

      <div className={`${style.venueContainer} ${style.rightMargin}`}>
        <div className={`fr-margin-right-xsmall ${style.copyContainer}`}>
          <div className="fr-p4 fr-strong">{venue.name}</div>
          <div className="fr-p4 fr-light">{venueDesc}</div>
        </div>
        <img className={style.venueLogo} src={venue.logo} />
        <div className={style.deliveryBox}>
          {venue.coming_soon_at && <ComingSoon sDate={venue.coming_soon_at} />}
          {!venue.coming_soon_at && (
            <FirstSlot orderMode={orderMode} slot={venue.first_time_slot} />
          )}
        </div>
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default ServiceBox
